/**
 * EcoF-Interactive-Tabs
 * Handles tab switching functionality
 */

(function() {
  'use strict';

  function initTabs(section) {
    const tabButtons = section.querySelectorAll('.ecof-tab-btn');
    const tabContents = section.querySelectorAll('.ecof-tab-content');

    if (tabButtons.length === 0 || tabContents.length === 0) return;

    tabButtons.forEach(button => {
      button.addEventListener('click', function() {
        const targetTab = this.getAttribute('data-tab');

        // Remove active class from all buttons
        tabButtons.forEach(btn => btn.classList.remove('active'));

        // Remove active class from all content
        tabContents.forEach(content => content.classList.remove('active'));

        // Add active class to clicked button
        this.classList.add('active');

        // Show corresponding content
        const targetContent = section.querySelector(`[data-content="${targetTab}"]`);
        if (targetContent) {
          targetContent.classList.add('active');
        }
      });
    });
  }

  // Initialize on page load
  document.addEventListener('DOMContentLoaded', function() {
    const sections = document.querySelectorAll('.ecof-tabs-section');
    sections.forEach(section => initTabs(section));
  });

  // Shopify theme editor support
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      const section = event.target;
      if (section.classList.contains('ecof-tabs-section')) {
        initTabs(section);
      }
    });
  }
})();
